// Supabase client wired through the typed env reader (`@/lib/env`).
// Hardcoded fallbacks intentionally removed — missing env vars now fail
// fast at boot via the Zod schema rather than silently using a stale URL.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/lib/env';

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
